import { AttributeAlias, AttributesAliases } from 'src/generated/dict.ts';

export const getPriceAttributeName = (shoppingCenter: string | null, currency: string | null) => {
    if (shoppingCenter === null) {
        return null;
    }
    const fullAlias = `${shoppingCenter}_${currency}` as AttributeAlias;
    const shopAlias = shoppingCenter as AttributeAlias;
    if (currency !== null && AttributesAliases[fullAlias] !== undefined) {
        return fullAlias;
    }
    if (AttributesAliases[shopAlias] !== undefined) {
        return shopAlias;
    }
    return null;
};
export const getPriceAttributeId = (shoppingCenter: string | null, currency: string | null) => {
    if (shoppingCenter === null) {
        return null;
    }
    return AttributesAliases[
        (currency
            ? `${shoppingCenter}_${currency}`
            : shoppingCenter) as AttributeAlias
    ] ?? AttributesAliases[shoppingCenter as AttributeAlias];
};
